import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface AttachReassignCompanyRequest {
  attachmentIds: number[];
  sourceCompanyId: string;
  destinationCompanyId: string;
}

const useAttachReassignCompanyApi = () => {
  const call = useCallback(
    (requestBody?: AttachReassignCompanyRequest) =>
      new Promise((resolve, reject) => {
        axiosInstance
          .post(api.reassignCompany(), requestBody)
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    attachReassignCompany: execute,
    isReassignLoading: isLoading,
  };
};

export default useAttachReassignCompanyApi;
